@if (ad !== null && !ad.reserved) {
  <div class="relative flex flex-col border border-[#E4E4E4] bg-[#FEFEFE] rounded-[6px] h-[235px] w-[253px] overflow-hidden">
    <!-- Bild -->
    <a class="relative flex w-full h-[134px] bg-[#F5F5F5] justify-center items-center overflow-hidden md:cursor-pointer" routerLink="/entry/{{ad.id}}">
      <kaz-blur-image [src]="ad.images.length > 0 ? (ad.images[ad.titleImageIndex] | imageSource) : getDummyPicture(ad)" [placeholder]="ad.images.length === 0"></kaz-blur-image>
    </a>
    <!-- Text & Preis -->
    <a class="flex flex-col p-2.5 gap-3 md:cursor-pointer" routerLink="/entry/{{ad.id}}">
      <span class="text-base text-[#161D26] font-medium line-clamp-2 break-words hyphens-auto" lang="de" [title]="ad.title">{{ad.title}}</span>
      @if (ad.category.subName !== 'Verschenken'  && +ad.price > 0) {
        <span class="text-sm text-[#56BA90] font-medium">€ {{ad.price | currency:'EUR':'':'1.0-0':'de-DE'}} {{ad.priceType === PriceType.VHB ? 'VHB' : '' }}</span>
      }
      <span class="absolute right-4 bottom-2.5 text-xs text-[#999999]/70 font-medium">{{ad.category.localityName && ad.category.localityName !== '' ? ad.category.localityName : ad.category.subName}}</span>
    </a>
  </div>
}
